module.exports = __webpack_public_path__ + "img/banner-mobile.1d5e796e.png";